<template>
  <SideModal
    :show="show"
    @update:show="
      {
        if (!state.loading) $emit('update:show', $event);
      }
    "
    location="right"
    close-on-overlay-click
    width="550px"
    data-cy="sso-modal"
  >
    <div class="con" data-cy="sso-modal-content">
      <div class="d-flex align-center justify-space-between">
        <div class="title">Blackbaud SKY API Integration Instructions</div>
        <v-btn
          color="transparent"
          icon
          @click="
            {
              if (!state.loading) $emit('update:show', false);
            }
          "
          data-cy="sso-modal-close"
          ><v-icon>mdi-close</v-icon></v-btn
        >
      </div>

      <v-text-field
        class="mt-5"
        label="Parent SSO Secret Key"
        color="primary"
        v-model="state.parentSso"
        :disabled="state.loading"
      ></v-text-field>
      <div>
        <div class="title mt-3">Parent SSO Redirect URL</div>
        <div class="d-flex justify-space-between align-center mt-2">
          <div style="color: gray">
            {{
              `https://api.ptcwizard.com/api/sso/skyapi?sso_token={token}&type=parent&state=${
                schoolStore.school!.district_id
              }&school=${schoolStore.school_id}`
            }}
          </div>
          <v-btn
            @click="
              {
                copyToClipboard(
                  `https://api.ptcwizard.com/api/sso/skyapi?sso_token={token}&type=parent&state=${
                    schoolStore.school!.district_id
                  }&school=${schoolStore.school_id}`
                );
              }
            "
            icon
            color="transparent"
            ><v-icon>mdi-content-copy</v-icon></v-btn
          >
        </div>
      </div>
      <v-text-field
        class="mt-5"
        label="Teacher SSO Secret Key"
        color="primary"
        v-model="state.teacherSso"
        :disabled="state.loading"
      ></v-text-field>
      <div>
        <div class="title mt-3">Teacher SSO Redirect URL</div>
        <div class="d-flex justify-space-between align-center mt-2">
          <div style="color: gray">
            {{
              `https://api.ptcwizard.com/api/sso/skyapi?sso_token={token}&type=teacher&state=${
                schoolStore.school!.district_id
              }&school=${schoolStore.school_id}`
            }}
          </div>
          <v-btn
            @click="
              {
                copyToClipboard(
                  `https://api.ptcwizard.com/api/sso/skyapi?sso_token={token}&type=teacher&state=${
                    schoolStore.school!.district_id
                  }&school=${schoolStore.school_id}`
                );
              }
            "
            icon
            color="transparent"
          >
            <v-icon>mdi-content-copy</v-icon>
          </v-btn>
        </div>
      </div>
      <div class="mt-5" style="color: gray">
        If you are using Blackbaud integration then a Blackbaud sync tool will appear in the
        integration page.
        <br />
        Save integration settings then connect to your Blackbaud account
        <br />
        After Blackbaud integration is ready to use, you'll be able sync from Blackbaud
        <br />
        <br />
        <a
          style="text-decoration: none; color: gray"
          href="https://ptcwizard.freshdesk.com/a/solutions/articles/3000109405"
          target="_blank"
        >
          <b>Click here for Instructions to connect SKY API</b>
        </a>
      </div>

      <div class="d-flex justify-end mt-5">
        <v-btn :loading="state.loading" @click="save">Save</v-btn>
      </div>
      <div class="mt-5"></div>
    </div>
  </SideModal>
</template>

<script setup lang="ts">
import type { BlackBaudIntegration } from "@/api_types/school";
import SideModal from "@/components/sideModal.vue";
import FetchService from "@/services/fetch.service";
import { useSchoolStore } from "@/stores/school";
import { copyToClipboard } from "@/utils";
import { watch } from "vue";
import { reactive } from "vue";

const props = defineProps<{
  show: boolean;
  data: BlackBaudIntegration;
}>();

const schoolStore = useSchoolStore();

const emit = defineEmits<{
  (event: "update:show", val: boolean): void;
  (event: "update:data", val: Partial<BlackBaudIntegration>): void;
}>();

const state = reactive({
  parentSso: props.data?.sso_secret_key_parent,
  teacherSso: props.data?.sso_secret_key_teacher,
  loading: false
});
watch([() => props.data, () => props.show], () => {
  Object.assign(state, {
    parentSso: props.data?.sso_secret_key_parent || "",
    teacherSso: props.data?.sso_secret_key_teacher || ""
  });
});

const save = async () => {
  state.loading = true;
  const res = await FetchService.fetchData("/integration/blackbaud", "put", {
    sso_secret_key_parent: state.parentSso,
    sso_secret_key_teacher: state.teacherSso
  });
  if (typeof res == "object" && "sso_secret_key_teacher" in res) {
    emit("update:data", res);
  }
  state.loading = false;
};
</script>

<style scoped lang="scss">
@use "@/assets/_vars.scss" as *;
@use "@/assets/_breakpoints.scss" as breakpoints;

.con {
  padding: 20px 40px;
}

.title {
  color: $primary;
  font-size: 1.25rem;
  font-weight: 600;
}
</style>
